import type { TFunction } from "i18next";
import * as yup from "yup";
import { withoutSpecialCharsAndNumbersRegex } from "../static/regex";

export const getFirstNameSchema = (t: TFunction) =>
  yup
    .string()
    .trim()
    .min(2, t("COMMONS.ERRORS.MINIMAL_LENGTH", { minimalLength: "2" }))
    .max(100, t("COMMONS.ERRORS.MAXIMAL_LENGTH", { maximalLength: "100" }))
    .required(t("COMMONS.ERRORS.REQUIRED"))
    .matches(withoutSpecialCharsAndNumbersRegex, t("COMMONS.ERRORS.NOT_ALLOWED_CHARS"));
